const nformat = {

    formatMoney(amount) {
        let value = parseFloat(amount).toFixed(0)
        var str = "";
        if (value.toString().length > 6) {
            let index1 = value.toString().length - 6;
            let index2 = value.toString().length - 3;
            str = value.toString().substring(0, index1) + " " + value.toString().substring(index1, index2) + " " + value.toString().substring(index2);
        }else if (value.toString().length > 3) {
            let index = value.toString().length - 3;
            str = value.toString().substring(0, index) + " " + value.toString().substring(index);
        }else {
            str = value.toString();
        }
        return str + ' kr';
    },

};
export default nformat;